import Th from "@/components/Table/Th";
import { table_head } from "../orders_sale_constants";

const OrdersSaleTableHead = ({ base, setBase }) => {
	const setAllOrder = (order, orderType) => {
		setBase({ ...base, order: order, orderType: orderType });
	};

	return (
		<thead>
			<tr>
				{table_head &&
					table_head.map((item, i) => {
						return (
							<Th
								key={i}
								item_name={item.name}
								item_size={item.size}
								item_order={item.order}
								order={base.order}
								setOrder={null}
								orderType={base.orderType}
								setOrderType={null}
								item_class={item.class}
								item_check_permission={item.check_permission}
								setAllOrder={setAllOrder}
							/>
						);
					})}
			</tr>
		</thead>
	);
};

export default OrdersSaleTableHead;
